/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiAPauseShapeIcon20Solid = forwardRef('MediaUiAPauseShapeIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M6.25 3C5.56 3 5 3.56 5 4.25v11.5c0 .69.56 1.25 1.25 1.25h1.5C8.44 17 9 16.44 9 15.75V4.25C9 3.56 8.44 3 7.75 3h-1.5Z" }),
        React.createElement("path", { d: "M12.25 3C11.56 3 11 3.56 11 4.25v11.5c0 .69.56 1.25 1.25 1.25h1.5c.69 0 1.25-.56 1.25-1.25V4.25C15 3.56 14.44 3 13.75 3h-1.5Z" })));
});
